import api from './api';
import type { MovementFeedRow, MovementType, PaginatedResponse } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/inventory/movement/feed`;

export interface FeedParams {
  page?: number;
  pageSize?: number;
  type?: MovementType;
  locationId?: string;
}

const inventoryFeedService = {
  getFeed: async (
    venueId: string,
    params: FeedParams = {},
  ): Promise<PaginatedResponse<MovementFeedRow>> => {
    const { page = 1, pageSize = 50, type, locationId } = params;
    const p: Record<string, unknown> = { page, pageSize };
    if (type) p.type = type;
    if (locationId) p.locationId = locationId;
    const response = await api.get(base(venueId), { params: p });
    return response.data;
  },
};

export default inventoryFeedService;
